import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PhotoCamera from '@material-ui/icons/PhotoCamera';

const styles = theme => ({
    root:{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
    },
    containerPhoto: {
      height: 160,
      width: 160,
      position: 'relative',
      //'&:hover': {
        //'& $imageBackdrop': {
          //opacity: 0.45,
        //}
      //}
    },
    photo: {
      borderRadius: '50%',
      backgroundSize: 'cover',
      height: '100%',
      width: '100%'
    },
    input: {
      display: 'none',
    },
    button: {
        margin: theme.spacing.unit
    },
    focusVisible: {},
    imageBackdrop: {
      borderRadius: '0 0 160px 160px',
      width: 160,
      height: 80,
      position: 'absolute',
      top: '50%',
      backgroundColor: theme.palette.common.black,
      opacity: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      transition: theme.transitions.create('opacity'),
        '&:hover': {
          opacity: 0.85,
        }
    }
});

class ProfilePhotoButton extends Component{
  constructor(props){
    super(props);

    this.state = {
      openModal: false
    };
  }

  render(){
    const { classes, urlPhoto, userName, edit, onChange } = this.props;
    const { openModal } = this.state

    return (
      <div className={classes.root}>
          <input accept="image/*"
            className={classes.input}
            id="icon-button-file" 
            type="file"
            onChange={onChange}/>

        <div className={classes.containerPhoto}>
          <img className={classes.photo}
            alt={'Imagen de perfil'}
            src={urlPhoto}
            onClick={event => this.setState({openModal: true})} />

          {
          edit && <label htmlFor="icon-button-file" className={classes.imageBackdrop}>
                    <PhotoCamera style={{color: 'white'}} />
                    <Typography variant="h6" style={{color: 'white'}} noWrap>
                      {"ACTUALIZAR"}
                    </Typography>
                  </label>
          }
        </div>

        <h1>{userName}</h1>

       
      </div>
    );
  }
}

ProfilePhotoButton.propTypes = {
  classes: PropTypes.object.isRequired,
  urlPhoto: PropTypes.string,
  userName: PropTypes.string,
  edit: PropTypes.bool,
  onChange: PropTypes.func
};

export default withStyles(styles)(ProfilePhotoButton);